import { render } from "./AssignInstructors.vue?vue&type=template&id=7311f49a&scoped=true"
import script from "./AssignInstructors.vue?vue&type=script&lang=js"
export * from "./AssignInstructors.vue?vue&type=script&lang=js"

import "./AssignInstructors.vue?vue&type=style&index=0&id=7311f49a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7311f49a"]])

export default __exports__